const appHeaderText = {
    eng: {
        aplicationBtn: "Get in touch",
        langBtn: "Az"
    },
    ru: {
        aplicationBtn: "Оставить заявку",
        langBtn: "Eng"
    },

    az: {
        aplicationBtn: "Müraciət et",
        langBtn: "Eng",
    }
}

export default appHeaderText